export default __webpack_public_path__ + "static/media/icon_information_circle_16_Regular.7ff5cc1c.svg";